import { createRouter, createWebHistory } from 'vue-router';

import PaperBoat from './components/PaperBoat.vue';
import JournalPage from './components/JournalPage.vue';
import AboutPage from './components/AboutPage.vue';


const routes = [
  {
    path: '/',
    name: 'PaperBoat',
    component: PaperBoat
  },
  {
    path: '/journal',
    name: 'JournalPage',
    component: JournalPage,
    props: route => ({ background: route.query.background })
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
